var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex relative-position"},[_c('div',{staticClass:"inline-flex full-width dot-container row justify-center absolute"},_vm._l((_vm.dots),function(dot,index){return _c('div',{key:index,class:['q-pa-xs', { 'cursor-pointer': _vm.isDotClickable(dot) }],on:{"click":function($event){return _vm.clickDot(dot)}}},[_c('div',{class:[
          'dot',
          {
            'stretch-dot': dot.active && _vm.stretchActive,
            [`bg-${_vm.color}`]: dot.active,
            'bg-grey-4': !dot.active
          }
        ]})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }